import { FieldRecommendationsAPI } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { QUERY_KEY } from './queryKey'

export const useEqipRecommendations = (resourceId?: string) => {
  return useQuery({
    queryKey: [QUERY_KEY.PRACTICE_RECOMMENDATION, resourceId],
    queryFn: () => {
      if (!resourceId) return null
      return FieldRecommendationsAPI.getRecommendation({ resourceId })
    },
    enabled: !!resourceId,
  })
}
